import createLucideIcon from '../createLucideIcon';

const LayoutTemplate = createLucideIcon('LayoutTemplate', [
  ['path', { d: 'M21 3H3v7h18V3z', key: 'cq2tmr' }],
  ['path', { d: 'M21 14h-5v7h5v-7z', key: '1dv32i' }],
  ['path', { d: 'M12 14H3v7h9v-7z', key: '1k92lm' }],
]);

export default LayoutTemplate;
